import axios from 'axios';
import { API_BASE_URL } from "../config/apiConfig";
const API_BASE =  API_BASE_URL;

export const TaskMediaApi = {
  // Get all media for a task
  getTaskMedia: async (token, taskId) => {
    try {
      console.log('🔍 Fetching media for task:', taskId);
      const response = await axios.get(`${API_BASE}/tasks/${taskId}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      
      const taskData = response.data?.response?.data;
      const images = taskData?.media?.images || [];
      const documents = taskData?.media?.documents || [];
      
      console.log(`📊 Found ${images.length} images and ${documents.length} documents`);
      
      const allMedia = [
        ...images.map(item => ({
          id: item.id,
          name: item.name,
          filename: item.file_name,
          originalName: item.original_name,
          size: item.size,
          sizeFormatted: item.size_formatted,
          mimeType: item.mime_type,
          type: 'image',
          url: item.url,
          thumbnail: item.thumbnail,
        })),
        ...documents.map(item => ({
          id: item.id,
          name: item.name,
          filename: item.file_name,
          originalName: item.original_name,
          size: item.size,
          sizeFormatted: item.size_formatted,
          mimeType: item.mime_type,
          type: 'document',
          url: item.url,
        }))
      ];
      
      return allMedia;
      
    } catch (error) {
      console.error('❌ getTaskMedia failed:', error.response?.data || error.message);
      return [];
    }
  },

  // Upload images
  uploadImages: async (token, taskId, images) => {
    console.log(`📤 Starting upload of ${images.length} images to task ${taskId}`);
    
    const formData = new FormData();
    
    images.forEach((image, index) => {
      console.log(`📎 Appending image ${index + 1}:`, {
        name: image.name,
        type: image.type,
        size: image.size,
        lastModified: image.lastModified
      });
      formData.append('images[]', image);
    });

    // Log FormData entries (for debugging)
    for (let pair of formData.entries()) {
      console.log('FormData entry:', pair[0], pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1]);
    }
    
    try {
      console.log('🚀 Sending request to:', `${API_BASE}/tasks/${taskId}/images`);
      
    const response = await axios.post(
  `${API_BASE}/tasks/${taskId}/images`,
  formData,
  {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
    onUploadProgress: (event) => {
      const percent = Math.round(
        (event.loaded * 100) / event.total
      );
      console.log(`Upload progress: ${percent}%`);
    }
  }
);
      
      console.log('✅ Upload images response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Upload images failed:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  },

  // Upload documents
  uploadDocuments: async (token, taskId, documents) => {
    console.log(`📤 Starting upload of ${documents.length} documents to task ${taskId}`);
    
    const formData = new FormData();
    
    documents.forEach((doc, index) => {
      console.log(`📎 Appending document ${index + 1}:`, {
        name: doc.name,
        type: doc.type,
        size: doc.size,
        lastModified: doc.lastModified
      });
      formData.append('documents[]', doc);
    });
    
    try {
      console.log('🚀 Sending request to:', `${API_BASE}/tasks/${taskId}/documents`);
      
      const response = await axios({
        method: 'post',
        url: `${API_BASE}/tasks/${taskId}/documents`,
        data: formData,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        },
      });
      
      console.log('✅ Upload documents response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Upload documents failed:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  },

  // Delete specific media
  deleteMedia: async (token, taskId, mediaId) => {
    try {
      const response = await axios.delete(`${API_BASE}/tasks/${taskId}/media/${mediaId}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('❌ Delete media failed:', error);
      throw error;
    }
  },
};

export default TaskMediaApi;